export default __webpack_public_path__ + "static/media/Blue.24a7c5f4.png";